<div *ngIf="busy" class="form-group row">
  <label class="col-md-3 col-form-label">&nbsp;</label>
  <div class="col-md-9">
    <span class="text-danger bold"
      ><i class="fas fa-spinner fa-spin"></i>&nbsp;Setting up payment
      form..</span
    >
  </div>
</div>
<form id="payment-form" action="/charge" method="get" class="flex flex-col gap-5">
  <div>
    <label class="font-medium mb-2" for="credit-card-card-holder">Card Holder <span class="payment-field-required">*</span></label>
    <div id="credit-card-card-holder" class="input-container"></div>
  </div>
  <div>
    <label class="font-medium mb-2" for="credit-card-card-number">Card Number <span class="payment-field-required">*</span></label>
    <div id="credit-card-card-number" class="input-container"></div>
  </div>
  <div class="flex items-center gap-5">
    <div>
      <label class="font-medium mb-2" for="credit-card-card-expiration">Expiration Date <span class="payment-field-required">*</span></label>
      <div id="credit-card-card-expiration" class="input-container"></div>
    </div>
    <div>
      <label class="font-medium mb-2" for="credit-card-card-cvv">Security Code <span class="payment-field-required">*</span></label>
      <div id="credit-card-card-cvv" class="input-container"></div>
    </div>
  </div>
  <!-- <div class="form-group">
    <span [hidden]="!tokenizerBusy"><i class="fas fa-spinner fa-spin"></i></span>
    <div [hidden]="tokenizerBusy" id="credit-card-submit"></div>
  </div> -->
</form>
